module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "background-color": "#252a2f",
      "text-color": "#fff",
      "active-text-color": "#ffd04b",
      "collapse": _vm.collapse,
      "default-openeds": _vm.defaultOpeneds,
      "default-active": _vm.$route.path
    }
  }, [_vm._l((_vm.permRouters), function(item) {
    return (!item.hidden && item.children) ? [(_vm.getShowingChildren(item.children)) ? _c('el-submenu', {
      key: item.name,
      attrs: {
        "index": item.name || item.path
      }
    }, [_c('template', {
      slot: "title"
    }, [(item.meta && item.meta.icon) ? _c('icon', {
      attrs: {
        "name": item.meta.icon,
        "scale": "2"
      }
    }) : _vm._e(), _vm._v(" "), (item.meta && item.meta.title) ? _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.generateTitle(item.meta.title)))]) : _vm._e()], 1), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? [_c('router-link', {
        key: child.name,
        attrs: {
          "to": {
            name: child.name,
            params: child.params,
            query: child.query
          }
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [(child.meta && child.meta.title) ? _c('span', [_vm._v(_vm._s(_vm.generateTitle(child.meta.title)))]) : _vm._e()])], 1)] : _vm._e()
    })], 2) : _vm._e()] : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c450622","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/layout/MenuPanel/index.vue
// module id = 330
// module chunks = 0